import Quill from 'quill'
import { TabelaAssinaturaBlot, CLASSE_CELULA_LOGO } from './quillTabelaAssinatura'
import { LOGO_PLACEHOLDER, TOOLTIPS_TOOLBAR } from './quillEditorConfig'

const Parchment: any = Quill.import('parchment')
const TECLA_ENTER = 13

export function aplicarTooltipsToolbar(quill: any) {
  const toolbarModule = quill && quill.getModule('toolbar')
  const toolbar: HTMLElement = toolbarModule && toolbarModule.container

  if (!toolbar) {
    return
  }

  Object.entries(TOOLTIPS_TOOLBAR).forEach(([seletor, titulo]) => {
    toolbar.querySelectorAll(seletor).forEach(elemento => elemento.setAttribute('data-tooltip', titulo))
  })
}

export function configurarTeclasTabelaAssinatura(quill: any) {
  const keyboard = quill.getModule('keyboard')

  keyboard.bindings[TECLA_ENTER] = keyboard.bindings[TECLA_ENTER] || []
  keyboard.bindings[TECLA_ENTER].unshift(
    { key: TECLA_ENTER, shiftKey: true, handler: (range: any) => aoPressionarShiftEnter(quill, range) },
    { key: TECLA_ENTER, shiftKey: false, handler: (range: any) => aoPressionarEnter(quill, range) },
  )
}

function celulaDaTabela(quill: any, index: number): any {
  const [linha] = quill.getLine(index)
  return linha && linha.statics && linha.statics.blotName === 'celula-assinatura' ? linha : null
}

function aoPressionarShiftEnter(quill: any, range: any): boolean {
  const celula = celulaDaTabela(quill, range.index)
  const linhaAtual = celula && celula.parent
  const corpoTabela = linhaAtual && linhaAtual.parent
  const tabela = corpoTabela && corpoTabela.parent

  if (!celula || !(tabela instanceof TabelaAssinaturaBlot)) {
    return true
  }

  const novaLinha = Parchment.create('linha-assinatura')
  const novaCelula = Parchment.create('celula-assinatura')

  novaLinha.appendChild(novaCelula)
  corpoTabela.insertBefore(novaLinha, linhaAtual.next)

  const primeiraLinha = corpoTabela.children.head
  const celulaLogo = primeiraLinha && primeiraLinha.children.head

  if (celulaLogo && celulaLogo.domNode.classList.contains(CLASSE_CELULA_LOGO)) {
    const rowspanAtual = parseInt(celulaLogo.domNode.getAttribute('rowspan') || '1', 10)
    celulaLogo.domNode.setAttribute('rowspan', String(rowspanAtual + 1))
  }

  quill.update('user')
  quill.setSelection(novaCelula.offset(quill.scroll), 0, 'user')

  return false
}

function aoPressionarEnter(quill: any, range: any): boolean {
  const celula = celulaDaTabela(quill, range.index)
  const tabela = celula && celula.parent && celula.parent.parent && celula.parent.parent.parent

  if (!celula || !(tabela instanceof TabelaAssinaturaBlot)) {
    return true
  }

  const novoParagrafo = Parchment.create('block')

  tabela.parent.insertBefore(novoParagrafo, tabela.next)

  quill.update('user')
  quill.setSelection(novoParagrafo.offset(quill.scroll), 0, 'user')

  return false
}

// Tabela de verdade (não float) — sobrevive ao Outlook/Gmail com 3+ linhas ao lado da logo
// (ver quillTabelaAssinatura.ts). A logo ocupa as 3 linhas iniciais via rowspan; Shift+Enter
// dentro da célula de texto adiciona mais linhas livremente (sem limite fixo).
//
// Construída direto via Parchment.create/insertBefore, não via dangerouslyPasteHTML: o
// conversor genérico de HTML colado do Quill (clipboard matchBlot) só sabe aplicar formato
// em blots de embed ou com formats() — pra um Container customizado (linha/célula/tabela)
// ele não reconstrói a estrutura, só acha os elementos "desconhecidos" e acaba desmontando.
export function inserirBlocoAssinatura(quill: any) {
  const selection = quill.getSelection(true)
  const index = selection ? selection.index : quill.getLength()

  const tabela = Parchment.create('tabela-assinatura')
  const corpo = Parchment.create('corpo-tabela-assinatura')
  const linhaLogo = Parchment.create('linha-assinatura')
  const celulaLogo = Parchment.create('celula-assinatura', { logo: true })
  const celulaNome = Parchment.create('celula-assinatura')
  const linhaEmail = Parchment.create('linha-assinatura')
  const celulaEmail = Parchment.create('celula-assinatura')
  const linhaTelefone = Parchment.create('linha-assinatura')
  const celulaTelefone = Parchment.create('celula-assinatura')

  celulaLogo.domNode.setAttribute('rowspan', '3')
  linhaLogo.appendChild(celulaLogo)
  linhaLogo.appendChild(celulaNome)
  linhaEmail.appendChild(celulaEmail)
  linhaTelefone.appendChild(celulaTelefone)
  corpo.appendChild(linhaLogo)
  corpo.appendChild(linhaEmail)
  corpo.appendChild(linhaTelefone)
  tabela.appendChild(corpo)

  const [linhaAtual] = quill.getLine(index)
  quill.scroll.insertBefore(tabela, linhaAtual ? linhaAtual.next : null)

  quill.insertEmbed(celulaLogo.offset(quill.scroll), 'image', LOGO_PLACEHOLDER, 'user')
  quill.insertText(celulaNome.offset(quill.scroll), 'Nome do Hospital', { bold: true }, 'user')
  quill.insertText(celulaEmail.offset(quill.scroll), 'contato@hospital.com.br', 'user')
  quill.insertText(celulaTelefone.offset(quill.scroll), '(11) 0000-0000', 'user')

  quill.update('user')
  quill.setSelection(celulaTelefone.offset(quill.scroll) + '(11) 0000-0000'.length, 0, 'user')
}
